import Axios from 'axios'
import MSConsultationsClient from './ms-consultations/ms-consultations.api'

class MSConsultationsSingleton {
  constructor() {
    const baseURL = import.meta.env.VITE_REACT_APP_URL_CONSULTATIONS
    const httpConfig = {
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)

    console.info(`Axios instance MSConsultations ${this.client.defaults.baseURL}`)

    //TODO: esto estaba puesto
    //this.client.interceptors.request.use(refreshTokenInterceptor);

    // IMPLEMENTATIONS
    this.msConsultations = new MSConsultationsClient(this.client)
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const MSConsultations = MSConsultationsSingleton.instance
export default MSConsultations
